export default function AppSetting() {
    return (
        <aside className="control-sidebar control-sidebar-dark">
            <div className="p-3">
                <h5>Configuraci&oacute;n</h5>
                <p>Configuraci&oacute;n de la aplicaci&oacute;n</p>
            </div>
        </aside>
    )
  }